<div class="dialog-container rounded-xl mt-0 m-t[-10px];">
  <div class="header-section w-full">
    <p class="expense-title">{{ data?.title ? (data.title == 'Cash Value Account' ? data?.title : data?.title) : 'Update Value' }}</p>
    <button type="button" class="close add-close-button" data-dismiss="modal" (click)="closedialog()">
      <span class="material-icons icons-close-mobile text-k-blue font-semibold text-2xl">close</span>
    </button>
  </div>
  <form [formGroup]="attributeForm" class="w-full m-auto">
    <!-- <mat-form-field appearance="fill" style="width: 100% !important" class="automtic-form-desing-form-only add-automtic-form-desing">
    <mat-label class="automtic-form-desing-lable"> Value </mat-label>
    <input matInput placeholder="Enter Value" type="number" formControlName="value_num" (keydown)="handleSum($event)" />
  </mat-form-field> -->
  <input-number-effect
    [fromPurchasePrice]="true"
    (newValue)="getValue($event)"
    [title]="data.inputTitle ?? data?.title"
    [styledIcon]="true"
    showLabel="{{ true }}"
    [isNegativeAllowed]="false"
  ></input-number-effect>
  @if (attributeForm.controls.value_num.touched && attributeForm.controls.value_num.errors) {
    <p
      style="font-weight: 400 !important; color: #f44336; font-size: 12px; margin-bottom: 0px; position: relative; top: -16px"
      >
      {{ data?.title ? data?.title : 'Value' }} is required or Invalid
    </p>
  }
  <div style="display: flex; justify-content: space-between"></div>
  <mat-form-field appearance="fill" class="automtic-form-desing-form-only add-automtic-form-desing full-width">
    <mat-label class="automtic-form-desing-lable"> Effective Date </mat-label>
    <input matInput [matDatepicker]="dp3" [min]="today" (click)="dp3.open()" formControlName="effective_date" />
    <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
    <mat-datepicker #dp3 disabled="false"></mat-datepicker>
  </mat-form-field>
</form>

<div class="action" style="border-top: 0px !important">
  <button
    mat-raised-button
    type="submit"
      [class]="
        attributeForm.valid && attributeForm.controls['value_num'].value != 0
          ? 'app__btn--primary h-12 mb-0 mt-0 rounded-lg'
          : 'app__btn--disabled h-12 mb-0 mt-0 rounded-lg'
      "
    (click)="addAttribute()"
    >
    Done
  </button>
</div>
</div>
